import {gsap} from "gsap";

const mountAnimation = gsap.timeline({paused: true})
    .addLabel('start')
    .from('.center .sub', {opacity: 0, y: '+=100', duration: .7}, 'start+=0.5')
    .from('.center .title', {opacity: 0, y: '+=120', duration: .7}, 'start+=0.8')
    .from('.center .update', {opacity: 0, width: '0', duration: .4,ease: "power1.out"}, 'start+=1.2')
    .from('.center .desc', {opacity: 0, duration: .4}, 'start+=1.2')
    .from('.center .quick-menu li:nth-child(1)', {opacity: 0, x: '-=50', duration: .4}, 'start+=1.8')
    .from('.center .quick-menu li:nth-child(2)', {opacity: 0, x: '+=50', duration: .4}, 'start+=1.8')
    .staggerFrom('.right-menu li', 0.8, {x: '+=150', opacity:0, rotation: 0, ease: "power2.out",}, 0.1, 'start+=2.2')
    .from('.scroll', {opacity: 0, duration: .6, onComplete:function(){
        $('.scroll').addClass('active')
        }}, 'start+=2.7')
    .from('.bottom-menu', {opacity: 0, y: '+=30', duration: .6}, 'start+=3.3')



$('.btn-scroll').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({ scrollTop: $($(this).attr('href')).offset().top}, 500, 'linear');
});



export default {
    id: '#section-header',
    enterStart() {
        mountAnimation.play();
    }
};



// WEBPACK FOOTER //
// ./src/js/section/main.js